<!--<h2 mat-subheader>{{ item?.label }}</h2>
<p>test</p>

<mat-list-item
  *ngFor="let child of item?.items"
  routerLinkActive="active"
  [routerLink]="child.link"
  [routerLinkActiveOptions]="{ exact: true }"
>
  <a matLine class="menu-link" *ngIf="!child.sub_menu">{{ child.label }}</a>
  <!--<a matLine class="menu-link" *ngIf="child.sub_menu">{{ child.label }}</a>-->
  <!--<mat-list-item
    *ngFor="let sub of child.sub_menu?.items"
    routerLinkActive="active"
    [routerLink]="sub.link"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <a matLine class="menu-link">{{sub.label }}</a>
  </mat-list-item>
</mat-list-item>-->

<h2 mat-subheader>{{ item?.label }}</h2>

<mat-nav-list>
  <ng-container *ngFor="let child of item?.items; let i = index">
    <!-- Main item -->
    <mat-list-item
      (click)="child.sub_menu ? toggle(i) : null"
      [class.has-submenu]="child.sub_menu"
      routerLinkActive="active"
      [routerLink]="child.link"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <a matLine class="menu-link">{{ child.label }}</a>
    </mat-list-item>

    <!-- Sub-menu appears directly beneath the link -->
    <div *ngIf="child.sub_menu && isExpanded(i)" class="sub-menu">
      <mat-list-item
        *ngFor="let sub_child of child.sub_menu?.items"
        routerLinkActive="active"
        [routerLink]="sub_child.link"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <a matLine class="menu-link">{{ sub_child.label }}</a>
      </mat-list-item>
    </div>
  </ng-container>
</mat-nav-list>